import { hasUserProfileMetadataValue } from "../../../utils/userProfileMetadataDisplay";

export const WIZARD_MODES = {
  NEW: "new",
  DETAIL: "detail",
  EDIT: "edit",
  SUDO_EDIT: "sudoEdit",
  CONTACT_EDIT: "contactEdit",
  SUBMIT_MARKET: "submitMarket",
};

/** Modes where per-field profile locks apply for basic users. */
const SELF_SERVICE_WIZARD_MODES = new Set([WIZARD_MODES.NEW, WIZARD_MODES.EDIT, WIZARD_MODES.SUBMIT_MARKET]);

/**
 * Identity fields (name, birth data) are read-only in detail and self-service contact edit.
 * @param {string} mode
 * @returns {boolean}
 */
export function isIdentityFieldReadOnly(mode) {
  return mode === WIZARD_MODES.DETAIL || mode === WIZARD_MODES.CONTACT_EDIT;
}

/**
 * Whether a stored user profile value locks an identity field in self-service wizard modes.
 * @param {string} fieldKey - e.g. "firstName", "sex", "birthNumber"
 * @param {Object} [user] - App user from session / appContext
 * @returns {boolean}
 */
function isFieldLockedByUserProfile(fieldKey, user) {
  if (!user) {
    return false;
  }
  if (fieldKey === "firstName") {
    return hasUserProfileMetadataValue(user.firstName);
  }
  if (fieldKey === "surname") {
    return hasUserProfileMetadataValue(user.lastName);
  }
  return hasUserProfileMetadataValue(user.metadata?.[fieldKey]);
}

/**
 * Whether an identity field should be disabled in the registration wizard / profile form.
 * @param {string} mode - {@link WIZARD_MODES} value
 * @param {string} fieldKey - e.g. "firstName", "sex", "birthNumber"
 * @param {Object} [user] - App user (session / appContext)
 * @returns {boolean}
 */
export function isIdentityFieldDisabled(mode, fieldKey, user) {
  if (isIdentityFieldReadOnly(mode)) {
    return true;
  }
  if (mode === WIZARD_MODES.SUDO_EDIT) {
    return false;
  }
  if (!SELF_SERVICE_WIZARD_MODES.has(mode)) {
    return false;
  }
  return isFieldLockedByUserProfile(fieldKey, user);
}
